import { api } from "./_client";

export async function reportClientError(payload) {
    const { data } = await api.post("/client-errors", payload);
    return data;
}

export async function listClientErrors() {
    const { data } = await api.get("/admin/client-errors");
    return data;
}

export async function deleteClientError(id) {
    const { data } = await api.delete(`/admin/client-errors/${id}`);
    return data;
}

export async function clearClientErrors() {
    const { data } = await api.delete("/admin/client-errors");
    return data;
}

// ----- Pricing strategies (superadmin-customisable labels + prompts) -----
